import React from "react";
import { Link } from "react-router";
import { browserHistory } from "react-router";
import axios from "axios";
import FormErrorHandler from "../components/FormErrorHandler";
import { isLoggedIn } from "../components/Utils";

export default class LoginPasswordLost extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formSubmitted: false,
      email: "",
      errorMessage: {}
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("/v1/auth/reset-password/?domain=crs", {
        email: this.refs.email.value
      })
      .then((response) => {
        this.setState({
          email: "",
          formSubmitted: true
        });
      })
      .catch((error) => {
        console.log(error);
        if (error && error.response && error.response.data) {
          this.setState({
            errorMessage: error.response.data
          });
        }
      });
  };

  componentDidMount() {
    if (isLoggedIn()) {
      browserHistory.push("/events");
    }
  }

  getLostContent() {
    let content = "";

    if (this.state.formSubmitted) {
      content = (
        <div>
          <p>Indien je e-mailadres bekend is in ons systeem, ontvang je binnen enkele minuten een e-mail met daarin een link om je wachtwoord opnieuw in te stellen.</p>
          <p>
            <Link className="btn btn-secondary" to="/">
              Terug naar inlogscherm
            </Link>
          </p>
        </div>
      );
    } else {
      content = (
        <div>
          <p>Geen probleem, wij sturen je graag per e-mail een link waar je het wachtwoord opnieuw in kunt stellen.</p>

          <form onSubmit={this.handleSubmit} ref="formref">
            <div className="form-group">
              <label htmlFor="inputEmail">E-mailadres</label>
              <input type="email" name="email" ref="email" className="form-control form-control-md" required={true} />
            </div>

            <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />

            <div className="form-group">
              <button className="btn btn-large btn-primary" type="submit">
                Verzenden
              </button>{" "}
              &nbsp;
              <Link className="btn btn-large btn-secondary" to="/">
                Terug naar loginscherm
              </Link>
            </div>
          </form>
        </div>
      );
    }
    return content;
  }

  render() {
    var passwordLostContent = this.getLostContent();

    return (
      <div>
        <div className="row justify-content-md-center">
          <div className="form form-signin col-6">
            <div className="section-top">
              <h1>Nog geen wachtwoord of wachtwoord vergeten?</h1>
            </div>

            {passwordLostContent}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/LoginPasswordLost.js